export enum LoadType {
  Europallet = "EUROPALLET",
  Other = "OTHER"
}
